import { Component, ElementRef, EventEmitter, Input, OnChanges, AfterViewInit, Output, ChangeDetectionStrategy } from "@angular/core";
@Component({
    selector: "roots-main-menu-button",
    templateUrl: "./roots-main-menu-button.component.html",
    styleUrls: ["./roots-main-menu-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RootsMainMenuButtonComponent implements OnChanges, AfterViewInit {
  @Output() menuEvent: EventEmitter<any> = new EventEmitter();
  @Input("isOpen") open: boolean;
  constructor(private _el: ElementRef<HTMLElement>) {}

  ngOnChanges(): void {
    this.isOpen();
  }

  ngAfterViewInit(): void {
    this.isOpen();
  }

  clickEvent(e: any) {
    this.menuEvent.emit(this.open);
  }

  // Toggles the burger/close animation on this component's own button (it used
  // document.querySelector("button"), i.e. whichever button came first on the page).
  isOpen() {
    this._el.nativeElement.querySelector("button")?.classList.toggle("on", !!this.open);
  }
}
